"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.eligiblePlansResultSchema = exports.activeClaimSummarySchema = exports.eligiblePlanSchema = exports.availableStepSchema = void 0;
const zod_1 = require("zod");
const admin_1 = require("./admin");
const types_1 = require("./Definitions/types");
exports.availableStepSchema = zod_1.z.object({
    step: types_1.stepSchema,
    planId: zod_1.z.string(),
    fragmentId: zod_1.z.string(),
    deadlineAt: zod_1.z.number(),
    priorityBucket: admin_1.priorityBucketSchema.nullable(),
});
exports.eligiblePlanSchema = zod_1.z.object({
    planId: zod_1.z.string(),
    manufacturerPartNumber: zod_1.z.string().nullable(),
    manufacturerName: zod_1.z.string().nullable(),
    generatorName: zod_1.z.string(),
    priority: zod_1.z.number().nullable(),
    createdAt: zod_1.z.number(),
    deadlineAt: zod_1.z.number().nullable(),
});
exports.activeClaimSummarySchema = zod_1.z.object({
    planId: zod_1.z.string(),
    claimExpiresAt: zod_1.z.number(),
});
exports.eligiblePlansResultSchema = zod_1.z.object({
    plans: exports.eligiblePlanSchema.array(),
    activeClaim: exports.activeClaimSummarySchema.nullable(),
});
//# sourceMappingURL=operator.js.map